module.exports = __webpack_public_path__ + "static/media/johnJones13.62b04861.png";